import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TLocationCoordinates } from '@monorepo/types';

@Component({
  selector: 'monorepo-click-tracking',
  templateUrl: './click-tracking.component.html',
  styleUrls: ['./click-tracking.component.scss'],
})
export class ClickTrackingComponent {
  @Input() imgSrc = 'https://t4.ftcdn.net/jpg/04/17/73/83/360_F_417738393_Xo0d9yxrald38yapI5mST9xg8Rwl1fEO.jpg';
  @Input() trackClicks: TLocationCoordinates[] = [
    {
      x: 38.403990024937656,
      y: 38.424821002386636,
    },
  ];

  @Input() dotColor: string = 'red';
  @Output() clickInfo = new EventEmitter<TLocationCoordinates>();

  clickedArea($event: MouseEvent) {
    const trackingContainer = $event.currentTarget as HTMLDivElement;
    const rect = trackingContainer.getBoundingClientRect();

    if (rect) {
      const finalPostion: TLocationCoordinates = {
        x: ($event.clientX - rect.left) / rect.width,
        y: ($event.clientY - rect.top) / rect.height,
        color: this.dotColor,
      };

      this.clickInfo.emit(finalPostion);
    }
  }
}
